import { IBlocks } from "@/types";
import { useStateManagement } from "./useStateManagement";

// Extend sidebar view to support block details and selected block
export type SettingsSidebarView =
    | "root"
    | "theme"
    | "pages"
    | "addBlock"
    | "heading"
    | "block-details";

export interface SettingsSidebarBlockDetails {
    block: any; // Use IBlocks if available
}

export type ThemeSection =
    | "background"
    | "colors"
    | "design"
    | "custom"
    | "heading-design"
    | null;

export function useSettingsSidebar() {
    // Sidebar view state
    const sidebarView = useStateManagement<SettingsSidebarView>(
        "settingsSidebarView",
        "root"
    );
    // Selected block for details
    const selectedBlock = useStateManagement<IBlocks | null>(
        "settingsSidebarSelectedBlock",
        null
    );
    // Theme section state (for theme sub-navigation)
    const themeSection = useStateManagement<ThemeSection>(
        "settingsSidebarThemeSection",
        null
    );
    return { ...sidebarView, selectedBlock, themeSection };
}
